const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		resourceRegisterKey: 'importerData'
	},

	model: {
		importParams: {}, // additional importParams for importer
	},

	events: {
		click: function(event){
			utils.performButtonAction(event)
		},
	},

	methods: {
		onBuild(){
			const {
				mailingListID,
				mailingID,
				setPropertiesType,
				propertyChanges,
			} = this.getResourceRegisterContent('subscriberImporterUploader') || {}

			if(mailingListID){
				this.model.importParams = {
					mailingListID,
					mailingID,
				}
				if(
					setPropertiesType === 'setProperties'
					||
					setPropertiesType === 'removeProperties'
				){
					this.model.importParams = {
						...this.model.importParams,
						setPropertiesType,
						propertyChanges,
					}
				}
			}
		},

		updateImportResponse(type = 'upload', importResponse){
			// TODO: translations?!

			let msg = ''
			let className = 'error'

			const {
				subscriberImportReport,
				errorCode = '',
				detail = '',
			} = (importResponse || {})

			if(subscriberImportReport){

				const {
					recipientCnt = 0,
					updatedRecipients = 0,
					newRecipients = 0,
					mailingID = 0,
					subscribersAssignedToMailingID = 0,
				} = subscriberImportReport


				const messages = ['<b>Import erfolgreich abgeschlossen!</b><br>']
				messages.push(recipientCnt + ' Empfänger verarbeitet.')

				if((updatedRecipients * 1) > 0){
					messages.push('Eigenschaften von ' + updatedRecipients + ' Empfänger(n) angepasst.');
				} else {
					messages.push(newRecipients + ' neue Empfänger hinzugefügt.');
				}

				// a mailingID is given
				if ((mailingID * 1) > 0) {
					messages.push(subscribersAssignedToMailingID + ' neue Empfänger der Aussendung (' + mailingID + ') hinzugefügt.')
				}

				className = 'success';

				let statusController
				if((statusController = getComponent('statusController', true))){
					statusController.addPanel('status.done.import');
				}

				msg = messages.join('<br>');

			} else {

				switch (errorCode) {
					case 'IMPORT_SUBSCRIBER_ERROR_1':
					case 'FEC_SUBSCRIBER_IMPORTER_MAILING_LIST_ID_MISSING':
						msg = '<b>FEHLER: Mailingliste wurde nicht übergeben!</b>';
						break;
					case 'IMPORT_SUBSCRIBER_ERROR_2':
						msg = '<b>FEHLER: Die übertragenen Daten beinhalteten keine (verwendbaren) Empfänger!</b>';
						break;
					case 'IMPORT_SUBSCRIBER_ERROR_3':
						let detailText = ''
						if(utils.isArray(detail)){
							detailText = detail.map(subscriber => `${(subscriber.email || '')}`).join('<br>')
						} else {
							detailText = detail
						}
						msg = `<b>FEHLER: Folgende E-Mail Adressen sind nicht korrekt:</b><br><br>${detailText}`;
						break;
					case 'IMPORT_SUBSCRIBER_ERROR_4':
						msg = '<b>FEHLER: Wert für Anrede "' + detail + '" ist nicht korrekt!</b><br>' +
							'Erlaubt sind folgende Werte:<br>' +
							'"f" = weiblich<br>' +
							'"m" = männlich<br>' +
							'"c" = Unternehmen<br>' +
							'"o" = Organisation<br>' +
							'"" = neutral<br>';
						break;
					case 'IMPORT_SUBSCRIBER_ERROR_5':
						msg = '<b>FEHLER: Mailingliste existiert nicht oder ist inaktiv!</b>';
						break;

					case 'FEC_SUBSCRIBER_IMPORTER_UPLOAD_HANDLING_ERROR':
					case 'FEC_SUBSCRIBER_IMPORTER_UPLOAD_INCOMPLETE':
						msg = `<b>FEHLER beim Verarbeiten der übertragenen Datei!<br>${errorCode}</b>`;
						break;

					default:
						this._handleError({
							component: 	this,
							error: 		importResponse,
						})
						msg = ''
						break;
				}
			}

			this.$.find('.uploadResult')
				.removeClass('error success progress')
				.addClass(className)
				.html(msg)
		},

		showSelect(){
			const baseActionKey = 'showSelect_address'
			const actionKey = baseActionKey + '_inEffect'

			return this.performAndStoreAction(
				actionKey,
				this.prepareAction(baseActionKey, undefined, {
					grantAllAddressTypes: true,
					selection: {
						connectionInclusive: false,
						hasActiveNewsletterEmail: true,
						disableFilters: {
							connectionInclusive: true,
							hasActiveNewsletterEmail: true,
						}
					},
				}, {
					source: {
						load: {
							componentData: {
								model: {
									titleKey: 'artcrm_addresses.showSelectModal.byFilter.title',
									buttons: [
										{
											buttonType: 'cancel'
										},
										{
											buttonTextKey: 'artcrm_addresses.showSelectModal.byFilter.button',
											mode: 'filters',
											buttonType: 'submit',
										}
									]
								}
							},
						},
					},
				}),
				true
			);
		},

		async importSubscriberViaArtCrmAddressFilters(resourceFilters){
			resourceFilters = resourceFilters || {}
			resourceFilters.offset = 0
			resourceFilters.limit = 99999999

			const actionContext = await this.performAction(
				this.prepareAction('importSubscriberViaArtCrmAddressFilters', undefined, undefined, {
					source: {
						submit: {
							data: {
								...(this.model.importParams || {}),
								type: 'artCrmAddressFilters',
								artCrmAddressResourceFilters: resourceFilters,
							},
						},
					},
				}),
				true
			)
			this.updateImportResponse('artCrmAddressFilters', ((actionContext || {}).response || {}).data || {})
		},


	},

	hooks: {
		/**
		 * handle modal select address decisions.
		 *
		 * @param $element
		 * @param options
		 */
		async onDecision($element, options){
			options = options || {};

			switch(options.decisionType){
				case 'submit':
					let table
					options.decisionComponent.find('templates_artCrm_address_table', c => table = c)
					if(table){
						const resourceFilters = utils.copy(table.getResourceFilters(storage, undefined, 'refreshResources')) || {}
						await this.importSubscriberViaArtCrmAddressFilters(resourceFilters)
					} else {
						break
					}

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		},
	},
};